import PropTypes from 'prop-types'
import React from 'react'
import Link from 'gatsby-link'

const isMobile = typeof window !== 'undefined' ? window.innerWidth < 480 : false

const Originals = ({ mobileImageSrc, desktopImageSrc }) => (
  <div className='originals'>
    <div className='originals__image'>
      <div className='image'>
        <img
          src={isMobile ? mobileImageSrc : desktopImageSrc}
          alt='attn originals'
        />
      </div>
    </div>
    <div className='originals__info'>
      <span className='originals__eyebrow'>
        Originals
      </span>
      <h2 className='originals__header'>Calling attention<br />to what matters</h2>
      <p className='originals__description'>
        We are the trusted partner for public figures, brands and platforms to
        engage Millennials and Gen Z around social good.
      </p>
      <div className='originals__link'>
        <Link
          to='/originals'
        >
          Explore
          <span className='fas fa-long-arrow-alt-right' />
        </Link>
      </div>
    </div>
  </div>
)

Originals.propTypes = {
  imageSrc: PropTypes.string
}

export default Originals



// WEBPACK FOOTER //
// ./src/components/originals.js